import {useRef, useEffect} from 'react';

function usePrevious<T>(value: T): T | undefined {
    const cache = useRef<T | undefined>(undefined);
    useEffect(
        () => {
            cache.current = value;
        },
        [value]
    );
    return cache.current;
}

export default usePrevious;